import Gradient from "../assets/imgs/gradienthunt.PNG";
import Boxshadow from "../assets/imgs/boxshadow.PNG";
import Haikei from "../assets/imgs/haikei.PNG";
import Bootstrap from "../assets/imgs/bootstrap.PNG";
import Keyframes from "../assets/imgs/keyframes.PNG";
import Fullpage from "../assets/imgs/fullpage.PNG";
import Anime from "../assets/imgs/animejs.PNG";
import Swiper from "../assets/imgs/swiperjs.PNG";
import Threejs from "../assets/imgs/threejs.PNG";
import Leaflet from "../assets/imgs/leaflet.PNG";
import Mui from "../assets/imgs/MUI.PNG";
import Reactbootstrap from "../assets/imgs/reactbootstrap.PNG";
import Nivo from "../assets/imgs/nivo.PNG";
import Undraw from "../assets/imgs/undraw.PNG";
import Framer from "../assets/imgs/framer.PNG";

export const items = [
  {
    name: "Gradient Hunt",
    image: Gradient,
    category: "Css",
    link: "https://gradienthunt.com/",
    button: "Link",
    desc: "Find or make color gradients",
    option: "Gradient Hunt"
  },
  {
    name: "Box-Shadow",
    category: "Css",
    image: Boxshadow,
    link: "https://box-shadow.dev/",
    button: "Link",
    desc: "Customizable box shadow"
  },
  {
    name: "Haikei",
    category: "Css",
    image: Haikei,
    link: "https://haikei.app/",
    button: "Link",
    desc: "Create custom svg waves,blobs,etc..."
  },
  {
    name: "Bootstrap",
    category: "Css",
    image: Bootstrap,
    link: "https://getbootstrap.com/",
    button: "Link",
    desc: "Most Popular CSS framework"
  },
  {
    name: "KeyFrames",
    category: "Css",
    image: Keyframes,
    link: "https://keyframes.app/",
    button: "Link",
    desc: "Collection of styling tools"
  },
  {
    name: "FullPage.Js",
    category: "JavaScript",
    image: Fullpage,
    link: "https://alvarotrigo.com/fullPage/#page1",
    button: "Link",
    desc: "Create full screen scrolling websites"
  },
  {
    name: "Anime.Js",
    category: "JavaScript",
    image: Anime,
    link: "https://animejs.com/",
    button: "Link",
    desc: "Custom JavaScript animations"
  },
  {
    name: "Swiper.js",
    category: "JavaScript",
    image: Swiper,
    link: "https://swiperjs.com/",
    button: "Link",
    desc: "Create beautiful carousel sliders"
  },
  {
    name: "Three.js",
    category: "JavaScript",
    image: Threejs,
    link: "https://threejs.org/",
    button: "Link",
    desc: "Create 3D images and scenes"
  },
  {
    name: "Leaflet.js",
    category: "JavaScript",
    image: Leaflet,
    link: "https://leafletjs.com/",
    button: "Link",
    desc: "Adding mobile friendly interacive maps"
  },
  {
    name: "MUI",
    category: "React",
    image: Mui,
    link: "https://mui.com/",
    button: "Link",
    desc: "Component library for react"
  },
  {
    name: "React-Bootstrap",
    category: "React",
    image: Reactbootstrap,
    link: "https://react-bootstrap.netlify.app/",
    button: "Link",
    desc: "Most popular react styling framework"
  },
  {
    name: "Nivo",
    category: "React",
    image: Nivo,
    link: "https://nivo.rocks/components/",
    button: "Link",
    desc: "SVG styling components for data"
  },
  {
    name: "Undraw.co",
    category: "React",
    image: Undraw,
    link: "https://undraw.co/illustrations",
    button: "Link",
    desc: "Illustration library"
  },
  {
    name: "Framer Motion",
    category: "React",
    image: Framer,
    link: "https://www.framer.com/motion/",
    button: "Link",
    desc: "Animation library"
  },
];

export default items;